import styled from 'styled-components';

export const Container = styled.div`
  width: 90%;
  max-width: 1100px;

  margin:0 auto;

  background: #FFFFFF;
`;

export const Title =  styled.h1`
  width: 100%;
  margin:0px 0px 15px 0px;
  padding: 0px;

  color:#000000;

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;

  border-bottom: 1px solid rgba(34,36,38,.15);

  display: inline-block;
`;

export const Button = styled.button`
  width: 150px;
  height: 54px;
  margin: 10px auto;
  background: ${props => props?.bgColor || '#E84A5F'};
  color: #FFFFFF;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 400;
  border: 0;
  border-radius: 5px;
  display: block;
  cursor: pointer;
  transition: all 0.8ms;

  &:hover {
    font-weight: 700;
    background: ${props => props?.bgColor || '#E84A5F'};
  }

`;
